import { render, staticRenderFns } from "./UsersCount.vue?vue&type=template&id=31e99920&"
import script from "./UsersCount.vue?vue&type=script&lang=js&"
export * from "./UsersCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports